import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { InfoBarModel } from 'models/InfoBar';

@Component({
	selector: 'panel-info-bar',
	templateUrl: './panel-info-bar.component.html',
	styleUrls: ['./panel-info-bar.component.scss'],
	imports: [NgClass, NgStyle]
})
export class PanelInfoBarComponent {
	@Input() infoData: InfoBarModel[] = [];
} 